var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container body-container"},[_c('page-heading',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Your companies")])]),_vm._v(" "),_c('companies-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }